module.exports = __webpack_public_path__ + "img/csm_Ersa-Selective-VERSAFLUX-VERSAFLEX-1070509-900x675_663aa572bc.d761d3ec.jpg";